import React from "react";

export default function Home() {
  return (
    <h1 className="slogan">
      <div>gain <em>experience.</em></div>
      <div>make some <em>noise.</em></div>
    </h1>
  );
}
